<div class="row d-flex justify-content-end">
    <a class="btn btn-sm btn-dark mr-5" [routerLink]="['/admin_panel/bucket_details']" routerLinkActive="router-link-active" >Back</a>
  </div>

  <div style="margin-right: 32px;">
    <div>
        <h4 class="title" style="margin-top: 15px;">Allocation</h4>
    </div>
  </div>

  <br>
  <div class="row" >
    <div class="col-md-4">
        <h5 class="form-lable">Choose Bank:</h5>
        <p-dropdown [options]="Bank_list" name='Bank_list_gets'  (onChange)="fetchuser_3()"  [(ngModel)]="Bank_list_gets" placeholder="Select" optionLabel="y"
            [showClear]="true"></p-dropdown>
    </div>
    <div class="col-md-4">
        <h5 class="form-lable">Choose Product:</h5>
        <select [(ngModel)]="product_list_gets" class="form-control">
            <option *ngFor="let item of product_list" [value]="item._id">{{item.product_type}}</option>
        </select>
    </div>
    <div class="col-md-4" *ngIf="booleans">
        <h5 class="form-lable">Choose Portfolio:</h5>
        <p-dropdown [options]="portfolio_list" name='portfolio_list_gets'  [(ngModel)]="portfolio_list_gets" placeholder="Select" optionLabel="y"
            [showClear]="true"></p-dropdown>
    </div>


    <div class="col-md-4">
      <h5 class="form-lable">Choose Designations</h5>
      <p-dropdown [options]="Designation_details1" (onChange)="fetchuser_1()" [(ngModel)]="report_to_design"
        placeholder="Report to Designations" optionLabel="y" [showClear]="true"></p-dropdown>
      </div>
      <div class="col-md-4">
      <h5 class="form-lable">Choose User Details</h5>
      <p-dropdown [options]="User_details1" (onChange)="Report_fetch()" [(ngModel)]="report_to"
        placeholder="Report to User Details" optionLabel="y" [showClear]="true"></p-dropdown>
      </div>
      <div class="col-md-4">
        <h5 class="form-lable">Action</h5>
          <button class="btn btn-primary" (click)="fetch_allocation_detail()">Fetch allocation Details</button>
      </div>
  </div>

  <div style="margin: 2px;padding-bottom: 15px;" >
    <div class="row">
        <div class="col-md-12">
            <div>
            <h4 class="title-f" style="color: #0a2440;font-weight: 600;border-bottom: 2px solid;">Accounts Details</h4>
            <h4 class="title-f">Accounts Details</h4>
            <div class="d-flex justify-content-end mt-3 mb-1">
                <button class="btn btn-primary" (click)="showPositionDialog()">Reallocate to</button>
            </div>
           <div class="animate" *ngIf="!loading">
           </div>
           <div class="d-flex justify-content-around" *ngIf="loading">
            <p><b style="font-size: 16px;">Accounts: </b>{{saved_Fields.length}}</p>
           </div>
            <p> Allocated Account Details </p>
            <div *ngIf="loading" >
                <ag-grid-angular #agGrid
                    style="width: auto; height: 600px;"
                    class="ag-theme-alpine"
                    [rowData]="saved_Fields"
                    [rowSelection]="'multiple'"
                    [columnDefs]="AllocationcolumnDefs"
                    [pagination]="true">
                </ag-grid-angular>
            </div>

            </div>
        </div>
    </div>
  </div>

  <p-dialog header="Allocate to" [(visible)]="displayPosition" position="center" [modal]="true"
  [style]="{width: '500px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <div class="row" style="margin-left: 0px;margin-right: 0px;">
      <div class="col-md-12">
          <div class="row" style="padding: 0px 0px 6px 10px;">
              <div class="col-md-12 detail-t">
                <div class="row">
                    <div class="col-md-12 ">
                      <h5 class="form-lable">Choose Designations</h5>
                      <p-dropdown [options]="Designation_details_one" (onChange)="fetchuser_2()" [(ngModel)]="report_to_design_one"
                        placeholder="Report to Designations" optionLabel="y" [showClear]="true" style="max-height: 100px !important;"></p-dropdown>
                      </div>
                      <br>
                      <div class="col-md-12">
                      <h5 class="form-lable">Choose User Details</h5>
                      <p-dropdown [options]="User_details2" (onChange)="Report_fetch_1()" [(ngModel)]="report_to_one"
                        placeholder="Report to User Details" optionLabel="y" [showClear]="true" style="max-height: 100px !important;"></p-dropdown>
                      </div>
                      <br>
                      <div class="col-md-12 mb-5">
                        <h5 class="form-lable mt-5" >Action</h5>
                          <button class="btn btn-primary mb-5" (click)="showPositionDialog_hide()">Re allocation</button>
                      </div>
                  </div>

              </div>

          </div>
      </div>
  </div>
</p-dialog>
